import module from 'contabilidad/polizas/module.js'
import * as moment from 'moment'

const schema = {
  Total: 'number',
  SubTotal: 'number',
  IVA: 'number',
  Impto_IVA_Importe: 'number',
  Total_Pago: 'number',
  transaccion: {
    Total: 'number',
  },
}


const cadA = 'P  AAAAMMDD    +      JJJJ 1 0          ' + 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX                                         11 1 0\\n'
const cadB = 'M1 CCCCCCCCCCCCCCCC               ZZZZZZZZZZZZZZZ      * YYYYYYYYY            0          0.0' + '                  NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN \\n'

const padEnd = (string, length) => string.substring(0, length).padEnd(length)

export class ProvisionGastosPagosService {
  constructor ($http, $schema) {
    this.$http = $http
    this.$schema = $schema
  }

  obtenerInformacion (fecha_inicio, fecha_fin, ID_Cliente, CuentaBancaria) {
    return this.$http.get('/kendu/contabilidad/polizas/provisionGastosPagos', {
      params: {
        fecha_inicio: fecha_inicio.toYMD(),
        fecha_fin: fecha_fin.toYMD(),
        ID_Cliente: ID_Cliente,
        CuentaBancaria: CuentaBancaria,
      },
      schema,
    })
  }

  codificar (data, inicio_poliza) {
    let cadenaPrincipal = ''
    let fechaA, fechaB, tipo, fechaEspecial
    try {
      data.forEach(function (item, indice) {
        if (item.Cta1) {
          fechaA = moment(item.Fecha_Movimiento).format('YYYYMMDD')
          fechaEspecial = moment(item.Fecha_Movimiento).format('DD/MM/YYYY')
          fechaB = padEnd('F-' + item.Facturas, 15)
          tipo = 2
          item.transaccion.forEach(function (value, index) {
            if (index === 0) {
              cadenaPrincipal += cadA
                .replace('AAAAMMDD', fechaA)
                .replace('+', tipo)
                .replace('JJJJ', ('000' + inicio_poliza).slice(-4))
                .replace('XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX', padEnd('PAGO DE GASTOS', 60))
            }

            if (index === 1) {
              cadenaPrincipal += cadB
                .replace('CCCCCCCCCCCCCCCC', padEnd(item.Cta2.replace(/-/g, ''), 16))
                .replace('ZZZZZZZZZZZZZZZ', padEnd(fechaEspecial, 15))
                .replace('*', value.Naturaleza === 'C' ? 0 : 1)
                .replace('YYYYYYYYY', padEnd(parseFloat(value.Total).toFixed(2), 9))
                .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', padEnd((item.Nombre_Proveedor), 43))
            } else {
              cadenaPrincipal += cadB
                .replace('CCCCCCCCCCCCCCCC', padEnd(value.Cuenta_Contable.replace(/-/g, ''), 16))
                .replace('ZZZZZZZZZZZZZZZ', fechaB)
                .replace('*', value.Naturaleza === 'C' ? 0 : 1)
                .replace('YYYYYYYYY', padEnd(parseFloat(value.Total).toFixed(2), 9))
                .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', padEnd((item.Nombre_Proveedor), 43))
            }
          })

          inicio_poliza++
        }
      })
      return cadenaPrincipal
    } catch (err) { // try
      console.info('error', err)
      return 'Error'
    }
  }
}

module.service('provisionGastosPagosService', ProvisionGastosPagosService)




// WEBPACK FOOTER //
// ./src/contabilidad/polizas/services/provisionGastosPagosService.js